import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import {Logout} from '../../backend/client'
import { successToaster } from '../../util/toaster';

const AdminHeader = () => {

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('userId')
    Logout();
    successToaster("Logged out successfully")
    navigate('/')
  }

  return (
    <nav className='bg-[#011539] flex justify-between items-center gap-5 p-3 px-[50px] ' >
      <div className='text-white' >
        Admin 
      </div>
      <div className=' flex gap-4 items-center ' >
        <Link className='text-white' to={'/'} >
            Home
        </Link>
        <button className='text-white bg-[#f02d1f] px-4 py-2 rounded-sm' onClick={handleLogout} >
            logout
        </button>
      </div>
    </nav>
  )
}

export default AdminHeader